import React from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { LockIcon } from "@icons";
import styles from "./TransactionLockColumnContent.module.scss";

interface Props {
    isLocked: boolean;
}

export const TransactionLockColumnContent: React.FC<Props> = ({ isLocked }) => {
    if (!isLocked) {
        return null;
    }

    return (
        <Tooltip
            content={
                <>
                    This transaction is locked.
                    <br />
                    To unlock, go to <strong>Settings &gt; Locks</strong>
                </>
            }
        >
            <span
                className={styles.value}
                data-testid="transaction-list-item-lock"
            >
                <LockIcon className="icon-color-current" />
            </span>
        </Tooltip>
    );
};
